module.exports = __webpack_public_path__ + "img/secondImage.bcc48180.png";